import { isEmptyString } from '@repo/shared/utils'
import { cn } from '@repo/ui/utils'
import { useEffect, useRef } from 'react'
import { useT } from './hooks'

interface ActionProps {
  autoFocus?: boolean
  className?: string
  isDisabled?: boolean
  onChange: (value: string) => void
  onSubmit?: () => void
  placeholder?: string
  value: string
}

export default function RichTextarea({
  autoFocus = true,
  className,
  isDisabled = false,
  onChange,
  onSubmit,
  placeholder,
  value,
}: ActionProps) {
  const { tc } = useT()
  const textareaRef = useRef<HTMLTextAreaElement>(null)
  useEffect(() => {
    if (!isDisabled && autoFocus) textareaRef.current?.focus()
  }, [isDisabled, autoFocus])
  return (
    <div className={cn('flex flex-col', className)}>
      <div
        className={cn(
          'border-b-none border-l-primary-200 border-r-primary-200 border-t-primary-200 relative flex flex-1 flex-col rounded-t-xl border bg-white px-1 pt-1 sm:px-4 sm:py-3',
        )}
      >
        <div className="flex w-full flex-1">
          <textarea
            ref={textareaRef}
            placeholder={placeholder ?? tc('write anything')}
            className="caret-primary disabled:text-primary-300 flex min-h-12 flex-1 resize-none bg-transparent placeholder:text-gray-400 focus:outline-none"
            readOnly={isDisabled}
            disabled={isDisabled}
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            onKeyDown={(e) => {
              if (e.metaKey && e.key === 'Enter' && !isEmptyString(value))
                onSubmit?.()
            }}
          />
        </div>
      </div>
      <div className="bg-custom-gradient h-2 rounded-b-xl px-2" />
    </div>
  )
}
